export enum ETag {
    green = "tag-green",
    purple = "tag-purple"
}